<template>
  <div>
    <div class="mx-auto">
      <v-divider></v-divider>
      <div class="mx-auto">
        <waterfall :col="col" :autoResize="true" :moveTransitionDuration="0.4" :fillBox="true"
                   :col-width="colWidth" :list="imgList" ref="waterfall" imgKey="url">
          <div class="img-item" :class="{bounceIn:item.state == 'show'}" slot-scope="item" @click="view(item)">

            <img v-if="item.data.url" class="waterfall-img" :src="item.data.url">
            <div class="img-text text-no-wrap text-truncate text-body-1">
              {{ item.data.name }}
            </div>
          </div>
        </waterfall>
        <v-btn @click="_list" v-if="imgList.length !== 0" bottom block>加载更多...</v-btn>
      </div>

      <div class="buttons-class">
        <classify-select v-model="classify"></classify-select>
        <type-select v-model="type" ></type-select>
        <back-top></back-top>
      </div>
    </div>
  </div>
</template>

<script>
import imgTypeSelect from '@/components/img/img-type-select'
import {mapMutations} from 'vuex'
import {list} from '@/api/resources/img'

import vueWaterfallRapid from 'vue-waterfall-rapid'
import backTop from "@/components/BackTop";
import ImgClassifySelect from "@/components/img/img-classify-select";

export default {
  name: "index",
  data: () => ({
    breakpoints: {
      1200: {
        rowPerView: 4,
      },
      800: {
        rowPerView: 3,
      },
      500: {
        rowPerView: 1,
      }
    },
    type: [],
    page: 1,
    classify: undefined,
    imgList: [
      {
        "name": "The eye above the desert",
        "url": "https://drscdn.500px.org/photo/1043918218/q%3D80_h%3D300/v2?sig=cb270d1ab847db42eb11112e27d9534968a5a4c6eaa0ee83dbf4073df13c4937",
        "id": 1043918218
      },
      {
        "name": "Ratcliffe Power Station",
        "url": "https://drscdn.500px.org/photo/1043937519/q%3D80_h%3D300/v2?sig=1d923895c6e234b2dc801c4de8704492b593e68e18ca6c48c957ff17270a4fb4",
        "id": 1043937519
      },
      {
        "name": "Tatras Night",
        "url": "https://drscdn.500px.org/photo/1043926475/q%3D80_h%3D300/v2?sig=7f48148adb48a5e5185a75db60f765fba33d3a9603152783309147e4f709358f",
        "id": 1043926475
      },
      {
        "name": "Breath of Dreams",
        "url": "https://drscdn.500px.org/photo/1043942055/q%3D80_h%3D300/v2?sig=9e0fbe64ac348ec96a4e6f81fc1a3c4df2641101bea0ed5bf7978c7b53042dd1",
        "id": 1043942055
      },
      {
        "name": "The drain. ",
        "url": "https://drscdn.500px.org/photo/1043930035/q%3D80_h%3D300/v2?sig=be63e9d889283885c365e255aed42a126374e3cab542534a57e47af1aa9c23f9",
        "id": 1043930035
      },
      {
        "name": "[ Sittin' On The Dock Of The Bay ]",
        "url": "https://drscdn.500px.org/photo/1043921431/q%3D80_h%3D300/v2?sig=d1dbc130119d0928d405320b816f006fffd8b5e2f63b5f2d43ec4b06f5f299b2",
        "id": 1043921431
      },
      {
        "name": "Winter forest magic",
        "url": "https://drscdn.500px.org/photo/1043917540/q%3D80_h%3D300/v2?sig=c12cfa493a066269373fa94f34b50e5101b337e7a43b7256347b074900c8ef4d",
        "id": 1043917540
      },
      {
        "name": "Queen of Flowers..",
        "url": "https://drscdn.500px.org/photo/1043921164/q%3D80_h%3D300/v2?sig=9455213c539003c43c1cc28f649214bed181c23f94cba3f5f916df0d8b1fac8a",
        "id": 1043921164
      },
      {
        "name": "Life Finds A Way",
        "url": "https://drscdn.500px.org/photo/1043940120/q%3D80_h%3D300/v2?sig=8c9b21244bacc4767796d54748783ffac3743e47bf7e86e948098558396a8b14",
        "id": 1043940120
      },
      {
        "name": "Way to the ocean",
        "url": "https://drscdn.500px.org/photo/1043917959/q%3D80_h%3D300/v2?sig=49096b8f44870439acba4ffcd37547f3c5307e2fdfbe4947bc7e7f3f94308708",
        "id": 1043917959
      },
      {
        "name": "Niagara Falls",
        "url": "https://drscdn.500px.org/photo/1043925302/q%3D80_h%3D300/v2?sig=7d88c4f618296f8affe6f11adb4d99b2406db5317836ac4d512f5faf1049fbd9",
        "id": 1043925302
      },
      {
        "name": "Solitary beach ",
        "url": "https://drscdn.500px.org/photo/1043940059/q%3D80_h%3D300/v2?sig=fd06c463a530b1b9e8c1ed0d57021536718582d1caff155fd54860627f08d242",
        "id": 1043940059
      },
      {
        "name": "Zinnia flowers",
        "url": "https://drscdn.500px.org/photo/1043920147/q%3D80_h%3D300/v2?sig=bd7d1d3a8e99e2d3022ebc5c6aeffd93edb818f6bb28a23be8b534d3eb23dd91",
        "id": 1043920147
      },
      {
        "name": "Frozen lake",
        "url": "https://drscdn.500px.org/photo/1043933755/q%3D80_h%3D300/v2?sig=e593a066257864a609220209d85efe3f5d8ba2ee548a11e73f5304b5ea6bc25d",
        "id": 1043933755
      },
      {
        "name": "心鱼心愿",
        "url": "https://drscdn.500px.org/photo/1043921880/q%3D80_h%3D300/v2?sig=d1ae0f6f0a1b32ed1f188f2aaa756cf97e4f6bdad957da2c1f320ab33f492479",
        "id": 1043921880
      },
      {
        "name": "*S*T*E*P*S*",
        "url": "https://drscdn.500px.org/photo/1043932159/q%3D80_h%3D300/v2?sig=465d5f09a9138c4554cca43efb9e50a9adc18335419e61f7109b51a5c23b0b67",
        "id": 1043932159
      },
      {
        "name": "Night at Skogafoss",
        "url": "https://drscdn.500px.org/photo/1043936057/q%3D80_h%3D300/v2?sig=a68a883124e77f7c71be949a6cc02604c10dac29b603746bfd17a3450b1f0d27",
        "id": 1043936057
      },
      {
        "name": "stormy sunday",
        "url": "https://drscdn.500px.org/photo/1043935303/q%3D80_h%3D300/v2?sig=52522267ddab89047be7beb089078960786b4900e0c373619efec41c935fc44a",
        "id": 1043935303
      },
      {
        "name": "Sunrise in Syðrugøta, Faroe Islands",
        "url": "https://drscdn.500px.org/photo/1043917872/q%3D80_h%3D300/v2?sig=9c2e3deffb191d5996e5fad4cc4f6a44bbb5bf747a07aaabedbbccf585b3b9ee",
        "id": 1043917872
      },
      {
        "name": "玉树琼花向雄峰",
        "url": "https://drscdn.500px.org/photo/1043945353/q%3D80_h%3D300/v2?sig=eab799a0ebba2f5ac815d3f7ac545a519c8582f1531aa80cb871deda933c6375",
        "id": 1043945353
      },
      {
        "name": "Senja",
        "url": "https://drscdn.500px.org/photo/1043935477/q%3D80_h%3D300/v2?sig=3150ec3e1c331145be02f5db8628adca7655a63df907fd52a53c737d5744a52b",
        "id": 1043935477
      },
      {
        "name": "Sunset clouds ",
        "url": "https://drscdn.500px.org/photo/1043934019/q%3D80_h%3D300/v2?sig=4e3a86938b1e69b4dfe9210cc35ec35934de5766c3ee6b370693156175c670ca",
        "id": 1043934019
      },
      {
        "name": "Gruppo delle Tofane e Cinque Torri ",
        "url": "https://drscdn.500px.org/photo/1043934003/q%3D80_h%3D300/v2?sig=c9074fee96f0da127981a4274a31cb0f5d9d74b5022bba6a0a15ceeb3325dad2",
        "id": 1043934003
      },
      {
        "name": "Blurry Flurry",
        "url": "https://drscdn.500px.org/photo/1043919317/q%3D80_h%3D300/v2?sig=cd045f6324fc547970c2ecef478686b7dd6ad5f6b8e14851fab1232b06f126dd",
        "id": 1043919317
      },
      {
        "name": "BLT sz",
        "url": "https://drscdn.500px.org/photo/1043927118/q%3D80_h%3D300/v2?sig=5377b3afaa3a32af7ec407dd79f757a4a08ca9e5cdeb55b46c4196dd0e2b4f5d",
        "id": 1043927118
      },
      {
        "name": "Badehaus Part II",
        "url": "https://drscdn.500px.org/photo/1043934102/q%3D80_h%3D300/v2?sig=3818c48470537d4dde7514ca9be892a2f1142e366f6f5e6971562fb0fd78437d",
        "id": 1043934102
      },
      {
        "name": "Raudafoss, Iceland",
        "url": "https://drscdn.500px.org/photo/1043936018/q%3D80_h%3D300/v2?sig=974c98daaa2ad8a16878508651079be4377797aeab5b648f0c2a7f31750fbea2",
        "id": 1043936018
      },
      {
        "name": "Ireland - Co.Sligo - Gleniff Horseshoe - Old school building",
        "url": "https://drscdn.500px.org/photo/1043914282/q%3D80_h%3D300/v2?sig=8df06017989405b9dc587447a224b4fcf3fad04ad540019d843315d98f5e3390",
        "id": 1043914282
      },
      {
        "name": "Autumn feeling",
        "url": "https://drscdn.500px.org/photo/1043935128/q%3D80_h%3D300/v2?sig=88a736b70e2507d15752751d6af15afe76438d6b89a1d2e1a4e7b03310fe3ca6",
        "id": 1043935128
      },
      {
        "name": "Autumn morning",
        "url": "https://drscdn.500px.org/photo/1043931631/q%3D80_h%3D300/v2?sig=721630014bcf5ed4e6138d92a019b34a187a81bc94473b02600e1bc984589787",
        "id": 1043931631
      },
      {
        "name": "Dolomiti 2021",
        "url": "https://drscdn.500px.org/photo/1043937921/q%3D80_h%3D300/v2?sig=992bcbada6181d8846c5c6cdf7c2fa60c0dc8ebf3206945163c9ea3be0cbf675",
        "id": 1043937921
      },
      {
        "name": "holding on",
        "url": "https://drscdn.500px.org/photo/1043916867/q%3D80_h%3D300/v2?sig=05d4fe0e1b265c74ef5b46326c61fc9fb3e230e97359a65b1631bf30e7f6d2de",
        "id": 1043916867
      },
      {
        "name": "Sunrise Is Really Spectacular ❤❤❤",
        "url": "https://drscdn.500px.org/photo/1043939513/q%3D80_h%3D300/v2?sig=cd4eb367bbc7082ee639877b65526d6b62600a692019a812433fb3aaa7c8532b",
        "id": 1043939513
      },
      {
        "name": "www.jeromecolombo.com",
        "url": "https://drscdn.500px.org/photo/1043933051/q%3D80_h%3D300/v2?sig=86e4be5fb1acabcca6260363ca1e53f91f6b2b18efb8a8e2635963147868dff8",
        "id": 1043933051
      },
      {
        "name": "Lights from bottom ",
        "url": "https://drscdn.500px.org/photo/1043937359/q%3D80_h%3D300/v2?sig=6882d2f48e4d4467416c82a7b44c7b1aa32de07b8328e6c5c464ce6fec633f3c",
        "id": 1043937359
      },
      {
        "name": "Midnight cruising to the Disko bay",
        "url": "https://drscdn.500px.org/photo/1043948843/q%3D80_h%3D300/v2?sig=f44898c3e897ada7daf0b2b1dac8c5fd69b0ec2063d1635e802dfafd457e82d6",
        "id": 1043948843
      },
      {
        "name": "Die Alpen",
        "url": "https://drscdn.500px.org/photo/1043919084/q%3D80_h%3D300/v2?sig=854af9831c94eebd0153f3cee993cd5e154d3e9601f5f9f6cec7b893bb140058",
        "id": 1043919084
      },
      {
        "name": "Frozen Mountain",
        "url": "https://drscdn.500px.org/photo/1043925157/q%3D80_h%3D300/v2?sig=0adf3a037ca7b643109f2f589e8a269ff3a8e3c7645ae725b2aa63cb22fc333f",
        "id": 1043925157
      },
      {
        "name": "February golden hour",
        "url": "https://drscdn.500px.org/photo/1043918727/q%3D80_h%3D300/v2?sig=a08d51a97ad5e2b972dc06ceb72a746d48286b6d24c88792c1b3beea874a40ee",
        "id": 1043918727
      },
      {
        "name": "Echo of the Sea",
        "url": "https://drscdn.500px.org/photo/1043936424/q%3D80_h%3D300/v2?sig=8458924af5c9f8ca5101302f2753edd6ebefc10591a82048c9e52fd858a06c00",
        "id": 1043936424
      },
      {
        "name": "Seattle - Looking West at Sunset",
        "url": "https://drscdn.500px.org/photo/1043936296/q%3D80_h%3D300/v2?sig=1998f6246b8a20bf88571772e81ae64fddd6a6d11179e1e51b30c5624cc1e25d",
        "id": 1043936296
      },
      {
        "name": "Saarschleife by night ",
        "url": "https://drscdn.500px.org/photo/1043931042/q%3D80_h%3D300/v2?sig=cc0c363bd50dbfeff147199b1cc291cafd0ffa5594ec0e67ae6554bc72da888b",
        "id": 1043931042
      }
    ],
    // autoResize: true,
    //是否始终填满容器
    // fillBox: true,
    //列宽-有指定列数则此属性失效
    colWidth: 240,
    //列数
    col: 0,
    lock: false
  }),
  components: {
    'classify-select': ImgClassifySelect,
    'type-select': imgTypeSelect,
    'waterfall': vueWaterfallRapid,
    'back-top': backTop
  },
  mounted() {
    // this._list();
  },
  methods: {
    ...mapMutations(['setLoading', 'clearLoading']),
    _list() {
      this.setLoading()
      let _param = {
        page: this.page,
        type: this.type.join(',')
      }
      list(_param).then(req => {
        this.imgList = this.imgList.concat(req.data.data)
        this.page++
      }).finally(() => {
        this.clearLoading()
        this.lock = false
      })
    },
    view({data}) {
      console.log(data.id, data.name)
    }
  },
}
</script>

<style scoped>
.buttons-class {
  position: absolute;
}

.waterfall-img {
  width: 100%;
  border-radius: 5px;
  display: block;
  position: relative;
}

.img-item {
  position: relative;
  margin: 5px;
}

.img-text {
  border-radius: 5px;
  text-align: left;
  position: absolute;
  z-index: 99;
  bottom: 0;
  left: 0;
  padding: 3px 5px;
  font-size: 13px;
  color: #fff;
  height: 30px;
  width: 100%;
  background-repeat: no-repeat;
  background-image: linear-gradient(transparent, rgba(0, 0, 0, 0.5));
}

</style>
